// Cantidad de imágenes del modo "Generar imagen personalizada"
// (kind `design-modelo`), ADR-2026-07-30-imagen-personalizada-cantidad.
//
// Con UNA sola pose (o pose Automática) el backend genera
// `cantidad_imagenes` variaciones con el MISMO prompt: en
// `atlas-backend/src/workers/handlers/generateAd.ts` la ola 1 es
// `wave1Count = multiPose ? 1 : data.cantidad_imagenes`, y `multiPose` es
// `poses.length + customs.length > 1`. Por eso con 2+ poses la cantidad se
// ignora (una imagen por pose, recomposición en la ola 2) y con "varios
// modelos" tampoco aplica (ese flow arma una composición grupal y ni
// siquiera rutea al backend nuevo — `modelo_mode: 'multiple'` va a n8n).
//
// El estado crudo del contador es el mismo `autoImageCount` que usan
// design-auto y anuncio (ver InterfazV2). Este helper lo traduce a la
// cantidad EFECTIVA para que el payload, el pill de créditos y la UI no se
// desincronicen: cuando el contador no aplica, la cantidad vuelve a 1 sin
// tocar el estado guardado.

export interface DesignModeloCountInput {
  /** Valor crudo del contador (`autoImageCount`). */
  rawCount: number;
  /** Poses seleccionadas. 0 = pose Automática (sigue siendo 1 generación). */
  poseCount: number;
  /** Modo "varios modelos" activo. */
  multiModelEnabled: boolean;
  /** Tope del contador (`AUTO_IMAGE_COUNT_MAX`). */
  max: number;
}

export interface DesignModeloCountResult {
  /** Si el contador se puede usar (y por lo tanto mostrar). */
  enabled: boolean;
  /** Cantidad de imágenes que realmente se van a pedir. */
  count: number;
}

export function resolveDesignModeloCount({
  rawCount,
  poseCount,
  multiModelEnabled,
  max,
}: DesignModeloCountInput): DesignModeloCountResult {
  const enabled = poseCount <= 1 && !multiModelEnabled;
  if (!enabled) return { enabled: false, count: 1 };
  const count = Math.max(1, Math.min(max, Math.trunc(rawCount) || 1));
  return { enabled: true, count };
}
